export default "__VITE_ASSET__BjNLgRhh__"